export default "__VITE_ASSET__9b5d56fa__"